import forEach from 'lodash/forEach';
import PrimitiveEE from './PrimitiveEE';



export default () => {
  let emittersByType = {};

  return {
    emit (type, ...args) {
      if (emittersByType.hasOwnProperty(type)) {
        emittersByType[type].emit(...args);
      }
    },

    on (type, callback) {
      if (!emittersByType.hasOwnProperty(type)) {
        emittersByType[type] = PrimitiveEE();
      }

      return emittersByType[type].on(callback);
    },

    cleanup () {
      forEach(emittersByType, (emitter) => {
        emitter.cleanup();
      });
      emittersByType = {};
    }
  };
};



// WEBPACK FOOTER //
// ./src/lib/TypedEE.js